<template lang="pug">
#NavBar
  .navbar-bg(:style="navbarBg")
  b-container(fluid="lg")
    .navbar-header
      div(style="cursor: pointer;" @click="$router.push('/')")
        picture
          // :TODO Se comenta logo avion, en logo normal estará en responsive
          //source(srcset="../../assets/logos/avion_naranjo.png" media="(max-width: 768px)")
          img.logo(src="../../assets/logos/blanco_avion.png")
      .user-info
        .user-info-item(v-if="user.store && !isMobile")
          div.user-icon.material-icons-outlined.mr-2 store
          div {{user.store.name}}
        .user-info-item
          span.user-icon.material-icons-outlined.mr-2(v-if="!isMobile") account_circle
          span(style="font-weight: 600;" v-if="!isMobile") {{fullName}}

          //- Dropdown Icono Escaner para vista conductor
          b-dropdown(v-if="isDriver" id="dropdown-1" @show="fetchUser()" right no-caret variant="link" toggle-class="text-decoration-none text-white")
            template(#button-content)
              span.material-icons-outlined qr_code_scanner

            b-dropdown-item(
              v-if="isDriver && user.canReceivePackages"
              :to="'/escaner-en-tienda'"
              exact
            ) Escanear en Tienda

            b-dropdown-item(
              v-if="isDriver && user.canReceivedInWarehouse"
              :to="'/recepcion-en-bodega'"
              exact
            ) Recepcionar en bodega

            b-dropdown-item(
              v-if="isDriver"
              :to="'/escaner-ruta-conductor'"
              exact
            ) Escanear ruta conductor

            b-dropdown-item(
                v-if="isDriver"
                to="/asignaciones-conductores/escanear-paquetes"
              ) Solicitar asignación de paquetes

          b-dropdown(@show="fetchUser()" id="dropdown-1" right no-caret variant="link" toggle-class="text-decoration-none text-white")
            template(#button-content)
              span.material-icons-outlined menu

            b-dropdown.pl-2(v-if="user.role === 'admin' || user.role === 'viewer' || isDriver && (user.canReceivePackages || user.canReceivedInWarehouse)"
              id="dropdown-2"
              dropright text="Escanear"
              variant="link"
              toggle-class="text-decoration-none"
            )
              b-dropdown-item(
                v-if="user.role === 'admin' || isDriver && user.canReceivePackages"
                :to="'/escaner-en-tienda'"
                exact
              ) Escanear en Tienda

              b-dropdown-item(
                v-if="user.role === 'admin' || user.role === 'viewer' || isDriver && user.canReceivedInWarehouse"
                :to="'/recepcion-en-bodega'"
                exact
              ) Recepcionar en bodega

              b-dropdown-item(
                v-if="user.role === 'admin' || isDriver"
                :to="'/escaner-ruta-conductor'"
                exact
              ) Escanear ruta conductor

              b-dropdown-item(
                v-if="user.role === 'admin' || user.role === 'viewer'"
                :to="'/cambios-devoluciones'"
                exact
              ) Cambios y devoluciones

              b-dropdown-item(
                v-if="isDriver"
                to="/asignaciones-conductores/escanear-paquetes"
              ) Solicitar asignación de paquetes

            b-dropdown-item(
              v-if="user.role === 'admin'"
              :to="'/configuracion'"
              exact
            ) Configuración

            b-dropdown-item(
              v-if="user.role === 'admin'"
              :to="'/eventos-webhook'"
              exact
            ) Eventos de webhooks

            b-dropdown-item(@click="logout") Cerrar Sesión

    b-navbar.bar.sombra(variant="light" toggleable="xl" v-if="hasNavbar")
      b-navbar-toggle(target="nav-collapse")
      b-collapse#nav-collapse.bg-white(is-nav)
        b-navbar-nav
          .link(v-if="user.role === 'warehouse'")
            .material-icons-outlined directions_car
            b-nav-item(:to="'/mis-envios'") Vista conductor
          .link(v-if="['admin', 'store', 'viewer'].includes(user.role)")
            .material-icons-outlined local_shipping
            b-nav-item(:to="'/envios-tienda'") Envíos
          .link(v-if="['admin', 'store', 'viewer', 'warehouse'].includes(user.role)")
            .material-icons-outlined local_shipping
            b-nav-item(:to="'/solicitudes-retiro'") Retiro
          .link(v-if="['admin', 'store', 'viewer', 'warehouse'].includes(user.role)")
            .material-icons-outlined event_note
            b-nav-item(:to="'/retiros-tienda'") Agendamiento
          .link(v-if="user.role==='admin'")
            .material-icons-outlined admin_panel_settings
            b-nav-item(:to="'/usuarios'") Adm.Usuarios
          .link(v-if="user.role==='admin'")
            .material-icons-outlined store
            b-nav-item(:to="'/tiendas'") Tiendas
          .link(v-if="user.role==='admin'")
            .material-icons-outlined near_me
            b-nav-item(:to="'/regiones'") Adm.Regiones
          .link(v-if="user.role==='store'")
            .material-icons-outlined manage_accounts
            b-nav-item(:to="'/mi-tienda'") Mi Tienda
          .link(v-if="user.role==='admin'")
            .material-icons-outlined email
            b-nav-item(:to="'/mensajes'") Mensajes
          .link(v-if="user.role==='admin'")
            .material-icons-outlined groups
            b-nav-item(:to="'/grupos'") Grupos
          .link(v-if="user.role==='admin'")
            .material-icons-outlined fact_check
            b-nav-item(:to="'/asignaciones-conductores'") Asignaciones ({{countPending}})
          .link(v-if="user.role==='admin'")
            .material-icons-outlined analytics
            b-nav-item(:to="'/control-de-gestion'") Control de Gestión

          .link(
            v-if="checkPermissions([permissions.STORE_SHOPIFY_INTEGRATION, permissions.STORE_API_ACCESS])"
          )
            .material-icons-outlined integration_instructions
            b-nav-item(:to="'/integraciones'") Integraciones
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { permissions } from '../../utils/authUtils'
import { isDriverRole } from '../../constants/userRoles'

export default {
  data() {
    return {
      permissions,
      fullName: {},
      isMobile: false
    }
  },
  mounted() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.fetchUser()
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  created() {
    this.getUser()
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    ...mapActions(['logout', 'fetchUser']),
    ...mapActions('assignment', ['getAssignmentRequestItemCountPending']),
    getUser() {
      const user = JSON.parse(localStorage.getItem('user')).user
      this.fullName = `${user.name} ${user.lastName}`
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    checkRole(roles) {
      return roles.includes(this.user.role)
    }
  },
  computed: {
    ...mapGetters(['user', 'checkPermissions']),
    ...mapGetters('assignment', ['countPending']),
    isDriver() {
      return isDriverRole(this.user.role)
    },
    hasNavbar() {
      return ['admin', 'store', 'viewer', 'warehouse'].includes(this.user.role)
    },
    navbarBg() {
      if (this.hasNavbar) {
        return 'height: calc(100% - 30px);'
      } else {
        return 'height: 100%;'
      }
    }
  },
  watch: {
    '$route.path': {
      handler() {
        if (this.user.role === 'admin') {
          this.getAssignmentRequestItemCountPending()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
#NavBar {
  position: relative;

  .navbar-bg {
    position: absolute;
    width: 100%;
    background-color: var(--secondary);
  }

  .navbar-header {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-height: 100px;
    padding: 5px 0;
    column-gap: 10px;
  }

  .user-info {
    position: relative;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    column-gap: 10px;
    flex-grow: 4;

    .user-info-item {
      display: flex;
      font-weight: 600;
      align-items: center;
      justify-content: flex-end;

      .dropdown {
        .btn {
          padding: 0 !important;
        }
      }
    }

    .user-icon {
      display: block !important;
      color: #FCA721;
      background-color: white;
      border-radius: 50%;
      border: 2px white solid;
    }

    color: white !important;
  }
}

#NavBar .navbar-header {
  @media (max-width: 768px) {
    min-height: 70px;
  }
}

.bar {
  height: 70px;
  border-radius: 10px;
  font-family: 'Source Sans Pro Semi Bold', sans-serif;
  font-weight: 700;
  font-size: 15px;
  z-index: 2;

  // Menú colapsado: se despliega como panel bajo la barra en vez de superponerse al contenido
  @media (max-width: 1199.98px) {
    ::v-deep .navbar-collapse {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      padding: 0.5rem 1rem;
      border-radius: 0 0 10px 10px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
    }
  }
}

.logo {
  position: relative;
  max-height: 60px;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    max-height: 35px;
  }
}

.link {
  color: var(--light-primary);
  align-items: center;
  display: flex;
  margin-right: 8px;
  white-space: nowrap;

  ::v-deep .nav-link {
    padding-left: 0.35rem;
    padding-right: 0.35rem;
  }

  // Notebooks (ej. 14"): barra más compacta para que los ítems no se corten
  @media (min-width: 1200px) and (max-width: 1599px) {
    margin-right: 0;
    font-size: 14px;

    .material-icons-outlined {
      font-size: 18px;
    }

    ::v-deep .nav-link {
      padding-left: 0.2rem;
      padding-right: 0.2rem;
    }
  }

  @media (min-width: 1200px) and (max-width: 1299px) {
    font-size: 13px;
  }
}

.scanner-btn {
  background-color: transparent;
  margin: 0.5rem;
  margin-left: 1rem;
  border: none;
  cursor: pointer;

}
</style>
